import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { PublicLinkService } from '@simOn/public-link';
import { SystemMessageComponent } from '@simOn/ui/system-message';
import { NotificationService } from '../notifications/notification.service';

/** A public link capability; derived from the service so this util lib needs no extra import. */
type PublicLinkCapability = Parameters<PublicLinkService['can']>[0];

@Injectable({
  providedIn: 'root'
})
export class PublicLinkNotificationService {
  private readonly _notificationService = inject(NotificationService);
  private readonly _publicLinkService = inject(PublicLinkService);
  private readonly _isPublicLinkModeActive = toSignal(this._publicLinkService.isPublicLinkModeActive$);

  /**
   * Blocks an action for public link visitors (with a toast). `unlockedBy` names the capability that allows the
   * action; legacy links answer through `legacyPublicLinkCapabilities` (no control, no scenes), JWT links through
   * the link's own capabilities.
   */
  isDisabledInPublicLinkToast(unlockedBy?: PublicLinkCapability) {
    if (this._isPublicLinkModeActive() && !(unlockedBy && this._publicLinkService.can(unlockedBy))) {
      const message = $localize`:@@ACTION_ONLY_IN_PUBLIC_LINK:This action is not available for a public link`;
      const instance = this._notificationService.openFromComponent(SystemMessageComponent, {
        verticalPosition: 'bottom',
        horizontalPosition: 'center'
      }).instance;
      instance.message.set(message);
      instance.type.set('error');
      return true;
    }
    return false;
  }
}
